<div class="text-muted-warm font-xs lh-1">
  {{ questionTitle }}
</div>

<div class="font-md mt-1 description-lh">
  {{ choicesStr }}
</div>
